import type { FunctionComponent } from 'react'

import { H2 } from '@monthio/design-system'
import {
	COLORS,
	DashboardCard,
	MaterialIcons,
	PrimaryButton,
} from '@monthio/react-components'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledCard = styled(DashboardCard)`
	width: initial;
	margin-bottom: 16px;
`

const StyledPre = styled.pre`
	background: ${COLORS.OTHER_COLORS.BRIGHT_BLUE};
	color: ${COLORS.GREY_SCALE.WHITE};
	padding: 12px;
	border-radius: 6px;
	display: flex;
	align-items: center;
`

const TextContainer = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-left: 8px;
`

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
`

const StyledPrimaryButton = styled(PrimaryButton)<{ $isLinkCopied: boolean }>`
	width: 100%;
	background: ${(props) =>
		props.$isLinkCopied
			? COLORS.OTHER_COLORS.AFFIRMATION_GREEN
			: COLORS.BRAND_COLORS.DARK_PERIWINKLE};

	${(props) => props.theme.breakpoints.up('sm')} {
		width: 250px;
	}
`

export const FlowLink: FunctionComponent<{
	secondaryApplicantFlowUrl?: string
}> = ({ secondaryApplicantFlowUrl }) => {
	const { t } = useTranslation()

	const [linkCopied, setLinkCopied] = useState(false)

	const handleCopy = useCallback(async () => {
		if (!secondaryApplicantFlowUrl) return
		await navigator.clipboard.writeText(secondaryApplicantFlowUrl)
		setLinkCopied(true)
	}, [secondaryApplicantFlowUrl])

	return (
		<StyledCard>
			<H2>
				{t(
					'genericLandingPage-coupleSameDeviceStart-copyToClipboard-explainer',
				)}
			</H2>

			<StyledPre>
				<MaterialIcons.Link />
				<TextContainer>{secondaryApplicantFlowUrl}</TextContainer>
			</StyledPre>
			{secondaryApplicantFlowUrl != null ? (
				<ButtonWrapper>
					<StyledPrimaryButton $isLinkCopied={linkCopied} onClick={handleCopy}>
						{linkCopied ? (
							<>
								<MaterialIcons.Check fontSize="small" />
								{t('genericLandingPage-coupleSeparateDeviceStart-linkCopied')}
							</>
						) : (
							<>
								<MaterialIcons.FileCopyOutlined fontSize="small" />
								{t('genericLandingPage-coupleSeparateDeviceStart-copyLink')}
							</>
						)}
					</StyledPrimaryButton>
				</ButtonWrapper>
			) : null}
		</StyledCard>
	)
}
